import { Id, useDynamicConfig, useEditDrawer } from "@dgs/core";
import { useCallback, useState } from "react";

export const useEditDrawerWithLocale = () => {
	const { languageSettings } = useDynamicConfig();
	const [editLocale, setEditLocale] = useState(languageSettings.fallback);
	const { handleOpen, ...editDrawerProps } = useEditDrawer();

	const handleOpenWithLocale = useCallback(
		(id: Id, locale?: string) => {
			setEditLocale(locale ?? languageSettings.fallback);
			handleOpen(id);
		},
		[languageSettings.fallback, handleOpen],
	);

	return { ...editDrawerProps, handleOpen: handleOpenWithLocale, editLocale };
};
